import script from "./industryuserList .vue?vue&type=script&lang=ts&setup=true"
export * from "./industryuserList .vue?vue&type=script&lang=ts&setup=true"

import "./industryuserList .vue?vue&type=style&index=0&id=7a89255c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a89255c"]])

export default __exports__